export default {"src":"/_next/static/media/appStoreBadge.a2e763b8.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};